import React, { FC, MutableRefObject } from 'react';
import { GridSize } from '@mui/material/Grid/Grid';
import { SystemProps } from '@mui/system/Box';
import { Breakpoint } from '@mui/material/styles';
import { Grid } from '@mui/material';
import cssVariables from '../../../../variables.module.scss';

type ResponsiveStyleValue<T> = T | Array<T | null> | { [key in Breakpoint]?: T | null };

interface ContentChildProps {
    children: React.ReactNode;
    // eslint-disable-next-line react/require-default-props
    size?: ResponsiveStyleValue<GridSize>;
    // eslint-disable-next-line react/require-default-props
    className?: string;
    // eslint-disable-next-line react/require-default-props
    sx?: SystemProps<{}>;
    // eslint-disable-next-line react/require-default-props
    gridRef?: MutableRefObject<any | undefined>
    // eslint-disable-next-line react/require-default-props
    id?: string;
}

const ContentChild: FC<ContentChildProps> = (props) => {
    const { children, size, className, sx, gridRef, id } = props;
    return (
        <Grid
            data-testid="ContentChild"
            container
            spacing={cssVariables.gapContentChild}
            size={size}
            columnGap={cssVariables.gapContentChild}
            className={className ?? undefined}
            sx={sx ?? undefined}
            ref={gridRef ?? undefined}
            direction="column"
            id={id ?? undefined}
        >
            {children}
        </Grid>
    );
};

export default ContentChild;
